import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Offcanvas,Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import ProformaInvoicePreview from './ProformaInvoicePreview';
// Add these imports at the top of ProformaInvoiceModal.jsx
import { format, parseISO } from 'date-fns';


const ProformaInvoiceModal = ({ showModal, quotationData, handleClose, quotationId, handleCreate, fetchQuotations, fetchDeals }) => {
    const [advanceAmount, setAdvanceAmount] = useState();
    const [amountReceived, setAmountReceived] = useState();
    const [balanceAmount, setBalanceAmount] = useState(0);
    const [proformainvoices, setProformaInvoice] = useState([]);
    const [deductionAmount, setDeductionAmount] = useState();
    const [invoicePercentage, setInvoicePercentage] = useState();
    const [revenueAmounts, setRevenueAmounts] = useState({
        deployment: { percentage: 0, amount: 0 },
        subscription: { percentage: 0, amount: 0 }
    });
    const [deploymentInput, setDeploymentInput] = useState('');
    const [subscriptionInput, setSubscriptionInput] = useState('');
    const [vatRate, setVatRate] = useState(0);
    const [totalContractWithVat, setTotalContractWithVat] = useState(0);
    const [vatAmount, setVatAmount] = useState(0);
    const [baseAmount, setBaseAmount] = useState(0);
    const [totalWithVat, setTotalWithVat] = useState(0);
    const [invoiceAmount, setInvoiceAmount] = useState();
    const [formErrors, setFormErrors] = useState({});
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [createdInvoice, setCreatedInvoice] = useState(null);
    const [customIntegration, setCustomIntegration] = useState('');
    const [editableDeploymentIntegration, setEditableDeploymentIntegration] = useState('');
    const [customIntegrationDescription, setCustomIntegrationDescription] = useState('');
    const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
    const [lockError, setLockError] = useState(null);


    const safeNumber = (value) => Number(value) || 0;

    // Calculate balances (BASE amounts without VAT)
    const clientCurrency = quotationData?.project?.client?.currency || 'AED';
    const isAED = clientCurrency === 'AED';
    const vatRateValue = isAED ? 0.05 : 0;

    // const deploymentTotal = safeNumber(quotationData?.revenueSplit?.deployment?.total);
    // const subscriptionTotal = safeNumber(quotationData?.revenueSplit?.subscription?.total);


     const isDirectOrder = quotationData?.deal?.is_direct_order === true;

    // Calculate deployment and subscription totals based on is_direct_order
    const deploymentTotal = isDirectOrder 
        ? safeNumber(quotationData?.deal?.one_time_cost ?? 0)
        : safeNumber(quotationData?.revenueSplit?.deployment?.total);

    const subscriptionTotal = isDirectOrder 
        ? safeNumber(quotationData?.deal?.recurring_cost ?? 0)
        : safeNumber(quotationData?.revenueSplit?.subscription?.total);
    const totalDeploymentReceived = proformainvoices?.reduce(
        (sum, pi) => sum + safeNumber(pi.deployment_amount),
        0
    ) || 0;

    const totalSubscriptionReceived = proformainvoices?.reduce(
        (sum, pi) => sum + safeNumber(pi.subscription_amount),
        0
    ) || 0;

    // FIXED: Calculate balances using BASE amounts only (without VAT)
    const deploymentBalance = Math.max(0, deploymentTotal - totalDeploymentReceived);
    const subscriptionBalance = Math.max(0, subscriptionTotal - totalSubscriptionReceived);

    console.log('quotaionmodal', quotationData);
    // Add this utility function
 const checkDateLockStatus = async (date) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            
            const response = await axios.get(`${backendUrl}/api/accounting/check-lock-status`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
                params: { date: format(new Date(date), 'yyyy-MM-dd') }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error checking lock status:', error);
            return { 
                is_locked: false, 
                period: null,
                error: error.message 
            };
        }
    };
const [isDateLocked, setIsDateLocked] = useState(false);

 useEffect(() => {
        const checkLock = async () => {
            if (!invoiceDate) return;
            
            const result = await checkDateLockStatus(invoiceDate);
            setIsDateLocked(result.is_locked);
            
            if (result.is_locked && result.period) {
                setLockError({
                    message: `The selected date is within a locked period: ${result.period.year_label}`,
                    period: result.period,
                    date: invoiceDate
                });
            } else {
                setLockError(null);
            }
        };
        
        if (showModal && invoiceDate) {
            checkLock();
        }
    }, [invoiceDate, showModal]);

    const validateForm = () => {
        const errors = {};
 if (isDateLocked) {
            errors.dateLocked = 'Cannot create invoice for a locked period';
        }
        if (!invoicePercentage || invoicePercentage === '' || parseFloat(invoicePercentage) <= 0) {
            errors.invoicePercentage = 'Percentage is required and must be greater than 0';
        }

        if (parseFloat(invoicePercentage) > 100) {
            errors.invoicePercentage = 'Percentage cannot exceed 100%';
        }

        return errors;
    };

   const calculateUpdatedBalancePercentage = () => {
    if (!quotationData.amount) return "0%";

    const clientCurrency = quotationData.project?.client?.currency || 'AED';
    const vatEffectiveDate = new Date('2020-09-01');
    const currentInvoiceDate = new Date(invoiceDate);
    const shouldApplyVAT = clientCurrency === 'AED' && currentInvoiceDate >= vatEffectiveDate;
    
    // FIXED: Use correct total based on VAT rules
    const totalAmount = Number(quotationData.amount) || 0;
    const correctTotalAmount = shouldApplyVAT ? totalAmount * 1.05 : totalAmount;
    
    const advancePercentage = Number(invoicePercentage) || 0;
    const deduction = Number(deductionAmount) || 0;
    const previousAdvancePaid = Number(amountReceived) || 0;

    // FIXED: Calculate advance value based on correct total
    const advanceValue = (correctTotalAmount * advancePercentage) / 100;
    const totalAdvancePaid = previousAdvancePaid + advanceValue;
    const remainingBalance = correctTotalAmount - totalAdvancePaid;

    if (remainingBalance < 0) {
        return "0%";
    }

    return `${((remainingBalance / correctTotalAmount) * 100).toFixed(2)}%`;
};
    const [referenceNumber, setReferenceNumber] = useState('');
    const [generatingRef, setGeneratingRef] = useState(false);

    // Add this function to generate reference number
    // Update the generateReferenceNumber function to accept date parameter
    const debounceRef = useRef(null);

    // Update the generateReferenceNumber function
    const generateReferenceNumber = async (selectedDate = null) => {
        try {
            setGeneratingRef(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const dateToUse = selectedDate || invoiceDate;

            const response = await axios.post(
                `${backendUrl}/api/prefixes/generate-reference-number`,
                {
                    name: 'Proforma Invoice',
                    date: dateToUse
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                }
            );

            if (response.data.success) {
                setReferenceNumber(response.data.reference_number);
                console.log('Generated Reference Number:', response.data.reference_number);
            }
        } catch (error) {
            console.error('Error generating reference number:', error);
        } finally {
            setGeneratingRef(false);
        }
    };

    // Remove the problematic useEffect and replace with this
    useEffect(() => {
        if (showModal) {
            setInvoicePercentage("");
            setInvoiceDate(new Date().toISOString().split('T')[0]);
            // Generate reference number only once when modal opens
            generateReferenceNumber(new Date().toISOString().split('T')[0]);
        }
    }, [showModal]);

    // Update the date field handler with debouncing
    const handleDateChange = (e) => {
        const newDate = e.target.value;
        setInvoiceDate(newDate);

        // Clear previous timeout
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
      setLockError(null);
        
        // Validate date immediately
        const validateDateImmediately = async () => {
            const result = await checkDateLockStatus(newDate);
            
            if (result.is_locked) {
                setIsDateLocked(true);
                setLockError({
                    message: `The selected date is within a locked period: ${result.period?.year_label || 'Unknown Period'}`,
                    period: result.period,
                    date: newDate
                });
                
                // Show immediate alert in form
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Date Locked',
                    text: `Cannot create invoice for ${newDate} - Period is locked`,
                    timer: 3000,
                    showConfirmButton: false,
                });
            } else {
                setIsDateLocked(false);
                setLockError(null);
            }
        };
        
        // Run validation
        validateDateImmediately();
        // Set new timeout - wait 500ms after user stops typing
        debounceRef.current = setTimeout(() => {
            generateReferenceNumber(newDate);
        }, 500);
    };

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);
    // Fallback method (your existing ref no generation)
    const generateFallbackRefNo = () => {
        const year = new Date().getFullYear().toString().slice(-2);
        const month = String(new Date().getMonth() + 1).padStart(2, '0');
        const userId = JSON.parse(localStorage.getItem('user-info'))?.id || '000';
        // You might need to get the last ID from your API
        const lastId = proformainvoices?.length + 1 || 1;
        return `ST/PI/${year}/${month}${userId}${String(lastId).padStart(4, '0')}`;
    };


    // FIXED: Main useEffect - Use BASE amounts only for calculations
    // useEffect(() => {
    //     if (!quotationData) return;

    //     const deploymentTotal = safeNumber(quotationData.revenueSplit?.deployment?.total);
    //     const subscriptionTotal = safeNumber(quotationData.revenueSplit?.subscription?.total);

    //     const invoicesArray = Array.isArray(proformainvoices) ? proformainvoices : [];

    //     // Calculate received amounts (BASE without VAT)
    //     const totalDeploymentReceived = invoicesArray.reduce(
    //         (sum, pi) => sum + safeNumber(pi.deployment_amount),
    //         0
    //     );

    //     const totalSubscriptionReceived = invoicesArray.reduce(
    //         (sum, pi) => sum + safeNumber(pi.subscription_amount),
    //         0
    //     );

    //     const clientCurrency = quotationData.project?.client?.currency || 'AED';
    //     const isAED = clientCurrency === 'AED';
    //     const vatRateValue = isAED ? 0.05 : 0;

    //     // FIXED: Calculate balances using BASE amounts only
    //     const deploymentBalance = Math.max(0, deploymentTotal - totalDeploymentReceived);
    //     const subscriptionBalance = Math.max(0, subscriptionTotal - totalSubscriptionReceived);

    //     setRevenueAmounts({
    //         deployment: {
    //             amount: deploymentBalance,
    //             percentage: deploymentTotal > 0 ? (deploymentBalance / deploymentTotal) * 100 : 0,
    //         },
    //         subscription: {
    //             amount: subscriptionBalance,
    //             percentage: subscriptionTotal > 0 ? (subscriptionBalance / subscriptionTotal) * 100 : 0,
    //         },
    //     });

    //     // Reset invoice fields
    //     setInvoiceAmount('');
    //     setInvoicePercentage('');

    //     // Calculate total received WITH VAT for display
    //     const totalReceived = invoicesArray.reduce(
    //         (sum, pi) => sum + safeNumber(pi.total_with_vat),
    //         0
    //     );

    //     const quotationTotalWithVat = safeNumber(quotationData.amount) * (1 + vatRateValue);

    //     const newAmountReceived = totalReceived;
    //     const newBalanceAmount = Math.max(0, quotationTotalWithVat - totalReceived);

    //     setAmountReceived(newAmountReceived);
    //     setBalanceAmount(newBalanceAmount);

    // }, [quotationData, showModal, proformainvoices]);

// FIXED: Main useEffect - Use BASE amounts only for calculations
useEffect(() => {
    if (!quotationData) return;

    const deploymentTotal = safeNumber(quotationData.revenueSplit?.deployment?.total);
    const subscriptionTotal = safeNumber(quotationData.revenueSplit?.subscription?.total);

    const invoicesArray = Array.isArray(proformainvoices) ? proformainvoices : [];

    // Calculate received amounts (BASE without VAT)
    const totalDeploymentReceived = invoicesArray.reduce(
        (sum, pi) => sum + safeNumber(pi.deployment_amount),
        0
    );

    const totalSubscriptionReceived = invoicesArray.reduce(
        (sum, pi) => sum + safeNumber(pi.subscription_amount),
        0
    );

    const clientCurrency = quotationData.project?.client?.currency || 'AED';
    
    // FIXED: Calculate VAT based on invoice date and UAE law
    const vatEffectiveDate = new Date('2020-09-01');
    const currentInvoiceDate = new Date(invoiceDate);
    const shouldApplyVAT = clientCurrency === 'AED' && currentInvoiceDate >= vatEffectiveDate;
    const vatRateValue = shouldApplyVAT ? 0.05 : 0;

    // FIXED: Calculate balances using BASE amounts only
    const deploymentBalance = Math.max(0, deploymentTotal - totalDeploymentReceived);
    const subscriptionBalance = Math.max(0, subscriptionTotal - totalSubscriptionReceived);

    setRevenueAmounts({
        deployment: {
            amount: deploymentBalance,
            percentage: deploymentTotal > 0 ? (deploymentBalance / deploymentTotal) * 100 : 0,
        },
        subscription: {
            amount: subscriptionBalance,
            percentage: subscriptionTotal > 0 ? (subscriptionBalance / subscriptionTotal) * 100 : 0,
        },
    });

    // Reset invoice fields
    setInvoiceAmount('');
    setInvoicePercentage('');

    // FIXED: Calculate total received - use actual invoice amounts (with or without VAT based on their dates)
    const totalReceived = invoicesArray.reduce(
        (sum, pi) => sum + safeNumber(pi.total_with_vat || pi.amount), // Use total_with_vat if available, else amount
        0
    );

    // FIXED: Calculate quotation total based on current invoice date VAT rules
    const quotationTotalWithoutVat = safeNumber(quotationData.amount);
    const quotationTotalWithVatValue = quotationTotalWithoutVat * (1 + vatRateValue);

    const newAmountReceived = totalReceived;
    
    // FIXED: Use correct total based on VAT rules for balance calculation
    const correctQuotationTotal = shouldApplyVAT ? quotationTotalWithVatValue : quotationTotalWithoutVat;
    const newBalanceAmount = Math.max(0, correctQuotationTotal - newAmountReceived);

    setAmountReceived(newAmountReceived);
    setBalanceAmount(newBalanceAmount);

}, [quotationData, showModal, proformainvoices, invoiceDate]);

    // useEffect(() => {
    //     if (!quotationData) return;

    //     const clientCurrency = quotationData.project?.client?.currency || 'AED';
    //     const isAED = clientCurrency === 'AED';
    //     const vatRateValue = isAED ? 0.05 : 0;

    //     setVatRate(vatRateValue);

    //     const totalContractWithoutVat = Number(quotationData.amount) || 0;
    //     const totalVatAmount = totalContractWithoutVat * vatRateValue;
    //     const totalContractWithVatValue = totalContractWithoutVat + totalVatAmount;

    //     setTotalContractWithVat(totalContractWithVatValue);
    //     setBaseAmount(totalContractWithoutVat);
    //     setVatAmount(totalVatAmount);
    //     setTotalWithVat(totalContractWithVatValue);
    // }, [quotationData]);

    // FIXED: Handle invoice percentage change
   
useEffect(() => {
    if (!quotationData) return;

    const clientCurrency = quotationData.project?.client?.currency || 'AED';
    
    // FIXED: Calculate VAT based on invoice date and UAE law
    const vatEffectiveDate = new Date('2020-09-01');
    const currentInvoiceDate = new Date(invoiceDate);
    const shouldApplyVAT = clientCurrency === 'AED' && currentInvoiceDate >= vatEffectiveDate;
    const vatRateValue = shouldApplyVAT ? 0.05 : 0;

    setVatRate(vatRateValue);

    const totalContractWithoutVat = Number(quotationData.amount) || 0;
    const totalVatAmount = totalContractWithoutVat * vatRateValue;
    const totalContractWithVatValue = totalContractWithoutVat + totalVatAmount;

    // FIXED: Set the correct total contract based on VAT rules
    setTotalContractWithVat(shouldApplyVAT ? totalContractWithVatValue : totalContractWithoutVat);
    setBaseAmount(totalContractWithoutVat);
    setVatAmount(totalVatAmount);
    setTotalWithVat(shouldApplyVAT ? totalContractWithVatValue : totalContractWithoutVat);
}, [quotationData, invoiceDate]);
   
    const handleInvoicePercentageChange = (value) => {
        const totalContractWithoutVat = Number(quotationData.amount) || 0;

        // Use BASE amounts for calculations
        const deploymentRemaining = deploymentBalance;
        const subscriptionRemaining = subscriptionBalance;
        const remainingBalance = deploymentRemaining + subscriptionRemaining;

        const maxPercentage = (remainingBalance / totalContractWithoutVat) * 100;
        const percentage = Math.min(Number(value) || 0, maxPercentage);

        setInvoicePercentage(percentage);

        // Calculate base amount (without VAT)
        const baseAmt = (totalContractWithoutVat * percentage) / 100;
        const cappedBaseAmt = Math.min(baseAmt, remainingBalance);

        // Calculate VAT and total with VAT
        const vatAmt = cappedBaseAmt * vatRate;
        const totalWithVatValue = cappedBaseAmt + vatAmt;

        setBaseAmount(cappedBaseAmt);
        setVatAmount(vatAmt);
        setTotalWithVat(totalWithVatValue);
        setInvoiceAmount(totalWithVatValue);

        // Split BASE amount proportionally (without VAT)
        const deploymentAmt = Math.min(
            (cappedBaseAmt * deploymentRemaining) / remainingBalance,
            deploymentRemaining
        );
        const subscriptionAmt = Math.min(cappedBaseAmt - deploymentAmt, subscriptionRemaining);

        setRevenueAmounts({
            deployment: {
                amount: deploymentAmt,
                percentage: deploymentRemaining > 0 ? (deploymentAmt / deploymentRemaining) * 100 : 0
            },
            subscription: {
                amount: subscriptionAmt,
                percentage: subscriptionRemaining > 0 ? (subscriptionAmt / subscriptionRemaining) * 100 : 0
            }
        });
    };

    // FIXED: Handle invoice amount change
    const handleInvoiceAmountChange = (value) => {
        const deploymentRemaining = deploymentBalance;
        const subscriptionRemaining = subscriptionBalance;
        const remainingBalance = deploymentRemaining + subscriptionRemaining;

        const totalWithVatInput = Number(value) || 0;

        // Convert VAT-inclusive amount to base amount
        const baseAmt = totalWithVatInput / (1 + vatRate);
        const vatAmt = baseAmt * vatRate;

        const cappedBaseAmt = Math.min(baseAmt, remainingBalance);
        const actualTotalWithVat = cappedBaseAmt + vatAmt;

        setBaseAmount(cappedBaseAmt);
        setVatAmount(vatAmt);
        setTotalWithVat(actualTotalWithVat);
        setInvoiceAmount(actualTotalWithVat);

        // Update percentage
        const totalContractWithoutVat = Number(quotationData.amount) || 0;
        const calculatedPercentage = totalContractWithoutVat > 0 ? (cappedBaseAmt / totalContractWithoutVat) * 100 : 0;
        setInvoicePercentage(calculatedPercentage);

        // Split BASE amount proportionally
        const deploymentAmt = Math.min(
            (cappedBaseAmt * deploymentRemaining) / remainingBalance,
            deploymentRemaining
        );
        const subscriptionAmt = Math.min(cappedBaseAmt - deploymentAmt, subscriptionRemaining);

        setRevenueAmounts({
            deployment: {
                amount: deploymentAmt,
                percentage: deploymentRemaining > 0 ? (deploymentAmt / deploymentRemaining) * 100 : 0
            },
            subscription: {
                amount: subscriptionAmt,
                percentage: subscriptionRemaining > 0 ? (subscriptionAmt / subscriptionRemaining) * 100 : 0
            }
        });
    };

    // FIXED: Deployment handlers
    const handleDeploymentChange = (value) => {
        setDeploymentInput(value.replace(/[^0-9.]/g, ''));
    };

    const handleDeploymentBlur = () => {
        const enteredValue = parseFloat(deploymentInput) || 0;

        // Convert VAT-inclusive input to base amount
        const enteredBase = vatRate > 0 ? enteredValue / (1 + vatRate) : enteredValue;

        // Max deployment cannot exceed remaining balance or remaining invoice
        const maxDeploymentBase = Math.min(deploymentBalance, baseAmount);

        const actualDeploymentBase = Math.min(enteredBase, maxDeploymentBase);
        const actualDeploymentTotal = vatRate > 0 ? actualDeploymentBase * (1 + vatRate) : actualDeploymentBase;

        // Auto-adjust subscription based on remaining invoice
        let remainingBase = baseAmount - actualDeploymentBase;
        remainingBase = Math.min(remainingBase, subscriptionBalance);
        const subscriptionTotal = vatRate > 0 ? remainingBase * (1 + vatRate) : remainingBase;

        setDeploymentInput(actualDeploymentTotal.toFixed(2));
        setSubscriptionInput(subscriptionTotal.toFixed(2));

        const deploymentTotalVal = quotationData.revenueSplit?.deployment?.total || 0;
        const subscriptionTotalVal = quotationData.revenueSplit?.subscription?.total || 0;

        setRevenueAmounts({
            deployment: {
                amount: actualDeploymentBase,
                percentage: deploymentTotalVal > 0 ? (actualDeploymentBase / deploymentTotalVal) * 100 : 0,
            },
            subscription: {
                amount: remainingBase,
                percentage: subscriptionTotalVal > 0 ? (remainingBase / subscriptionTotalVal) * 100 : 0,
            },
        });
    };

    // FIXED: Subscription handlers
    const handleSubscriptionChange = (value) => {
        setSubscriptionInput(value.replace(/[^0-9.]/g, ''));
    };

    const handleSubscriptionBlur = () => {
        const enteredValue = parseFloat(subscriptionInput) || 0;

        // Convert VAT-inclusive input to base amount
        const enteredBase = vatRate > 0 ? enteredValue / (1 + vatRate) : enteredValue;

        // Max subscription cannot exceed remaining balance or remaining invoice
        const maxSubscriptionBase = Math.min(subscriptionBalance, baseAmount);

        const actualSubscriptionBase = Math.min(enteredBase, maxSubscriptionBase);
        const actualSubscriptionTotal = vatRate > 0 ? actualSubscriptionBase * (1 + vatRate) : actualSubscriptionBase;

        // Auto-adjust deployment based on remaining invoice
        let remainingBase = baseAmount - actualSubscriptionBase;
        remainingBase = Math.min(remainingBase, deploymentBalance);
        const deploymentTotal = vatRate > 0 ? remainingBase * (1 + vatRate) : remainingBase;

        setSubscriptionInput(actualSubscriptionTotal.toFixed(2));
        setDeploymentInput(deploymentTotal.toFixed(2));

        const deploymentTotalVal = quotationData.revenueSplit?.deployment?.total || 0;
        const subscriptionTotalVal = quotationData.revenueSplit?.subscription?.total || 0;

        setRevenueAmounts({
            deployment: {
                amount: remainingBase,
                percentage: deploymentTotalVal > 0 ? (remainingBase / deploymentTotalVal) * 100 : 0,
            },
            subscription: {
                amount: actualSubscriptionBase,
                percentage: subscriptionTotalVal > 0 ? (actualSubscriptionBase / subscriptionTotalVal) * 100 : 0,
            },
        });
    };

    // FIXED: Update input initialization to show correct amounts
    useEffect(() => {
        const deploymentTotalAmt = vatRate > 0 ?
            revenueAmounts.deployment.amount * (1 + vatRate) :
            revenueAmounts.deployment.amount;

        const subscriptionTotalAmt = vatRate > 0 ?
            revenueAmounts.subscription.amount * (1 + vatRate) :
            revenueAmounts.subscription.amount;

        setDeploymentInput(
            revenueAmounts.deployment.amount === 0 ? '' : deploymentTotalAmt.toFixed(2)
        );
        setSubscriptionInput(
            revenueAmounts.subscription.amount === 0 ? '' : subscriptionTotalAmt.toFixed(2)
        );
    }, [revenueAmounts.deployment.amount, revenueAmounts.subscription.amount, vatRate]);

    const handleCreateProformaInvoice = async () => {
    if (isDateLocked) {
            Swal.fire({
                icon: 'error',
                title: 'Period Locked',
                html: `
                    <p>Cannot create invoice. The selected date is within a locked period:</p>
                    ${lockError?.period ? `
                    <p><strong>${lockError.period.year_label}</strong><br/>
                    ${format(parseISO(lockError.period.start_date), 'dd MMM yyyy')} to 
                    ${format(parseISO(lockError.period.end_date), 'dd MMM yyyy')}</p>
                    ` : `<p>Selected Date: ${invoiceDate}</p>`}
                `,
                confirmButtonText: 'OK'
            });
            return;
        }   
     const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please fix the form errors',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        setFormErrors({});
        try {
            const clientCurrency = quotationData.project?.client?.currency || 'AED';
            const deploymentVat = revenueAmounts.deployment.amount * vatRate;
            const subscriptionVat = revenueAmounts.subscription.amount * vatRate;

            const deploymentTotalWithVat = revenueAmounts.deployment.amount + deploymentVat;
            const subscriptionTotalWithVat = revenueAmounts.subscription.amount + subscriptionVat;

            console.log("VAT Calculation Details:", {
                deployment_base: revenueAmounts.deployment.amount,
                deployment_vat: deploymentVat,
                deployment_total_with_vat: deploymentTotalWithVat,
                subscription_base: revenueAmounts.subscription.amount,
                subscription_vat: subscriptionVat,
                subscription_total_with_vat: subscriptionTotalWithVat
            });

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            if (!baseAmount || baseAmount <= 0) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'warning',
                    title: 'Invoice amount must be greater than zero.',
                    timer: 3000,
                    showConfirmButton: false,
                });
                return;
            }

            const response = await axios.post(
                `${backendUrl}/api/proformainvoice`,
                {
                    quotation_id: quotationData.id,
                    quot_total_amount: quotationData.amount,
                    quot_total_amount_with_vat: totalContractWithVat,
                    advanced_amount: Number(invoicePercentage),
                    total_amount_received: amountReceived,
                    deduction_amount: deductionAmount,
                    deployment_amount: Number(revenueAmounts.deployment.amount) || 0,
                    subscription_amount: Number(revenueAmounts.subscription.amount) || 0,
                    vat: vatAmount,
                    basic_amount: baseAmount,
                    total_with_vat: totalWithVat,
                    currency: clientCurrency,
                    vat_rate: vatRate,
                    deployment_vat: deploymentVat,
                    subscription_vat: subscriptionVat,
                    deployment_total_with_vat: deploymentTotalWithVat,
                    subscription_total_with_vat: subscriptionTotalWithVat,
                    ref_no: referenceNumber, // Add the generated reference number
                    serial_no: referenceNumber, // Add the generated reference number
                    invoice_date: invoiceDate
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );

            const createdPI = response.data.proformainvoice;
            setProformaInvoice(prev => [...(prev || []), createdPI]);

            if (handleCreate) {
                handleCreate(createdPI);
            }

            setAmountReceived(createdPI.total_with_vat);
            setBalanceAmount(createdPI.balance);
            let journalId = null;
            try {
                journalId = await runBeforeEntry(createdPI, quotationData, {
                    deploymentAmount: revenueAmounts.deployment.amount || 0,
                    subscriptionAmount: revenueAmounts.subscription.amount || 0
                });

                // 3️⃣ Update invoice with journal_id
                await axios.put(
                    `${backendUrl}/api/proformainvoice/${createdPI.id}`,
                    { journal_id: journalId },
                    { headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin } }
                );

                console.log("✅ Journal ID saved in invoice:", journalId);

            } catch (entryErr) {
                console.error("Webzash Entry Failed:", entryErr);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'warning',
                    title: 'Invoice created, but accounting entry failed.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                });
            }

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Proforma Invoice created successfully!',
                timer: 3000,
                timerProgressBar: true,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },

            });
            console.log("2. After success message - before closing create modal");

            // Close create modal and open preview modal
            // handleClose();
            console.log("3. After handleClose - before opening preview");
            setCreatedInvoice(createdPI);

            // Use setTimeout to ensure state updates properly
            setTimeout(() => {
                setShowPreviewModal(true);
                console.log("✅ showPreviewModal set to: true");
            }, 100);


            await fetchDeals();

        } catch (error) {
            console.error('Error creating Proforma Invoice:', error);
            // Error handling remains the same...
        }
    };

    const handleClosePreview = () => {
        setShowPreviewModal(false);
        setCreatedInvoice(null);
    };

    const handleDownloadPDF = async () => {
        try {
            // Implement PDF download logic here
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/proformainvoice/${createdInvoice.id}/download`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob'
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `proforma-invoice-${createdInvoice.ref_no}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error('Error downloading PDF:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to download PDF',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };



    const [quotationWithPricings, setQuotationWithPricings] = useState(null);


    useEffect(() => {
        if (showModal && quotationData.id) {
            const fetchProformaInvoice = async () => {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    const response = await axios.get(
                        `${backendUrl}/api/proformainvoice?quotation_id=${quotationData.id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                'Tenant-Origin': origin,
                            },
                            skipLoader: true,
                        }
                    );

                    const proformaInvoices = response.data.proformainvoice || [];
                    const totalReceived = response.data.total_received || 0;
                    const balanceAmount = Number(response.data.balance || 0);
                    const clientCurrency = quotationData.project?.client?.currency || 'AED';
                    const isAED = clientCurrency === 'AED';
                    const vatRateValue = isAED ? 0.05 : 0;

                    if (proformaInvoices && Array.isArray(proformaInvoices) && proformaInvoices.length > 0) {
                        setProformaInvoice(proformaInvoices);
                        setAmountReceived(totalReceived || 0);
                        setBalanceAmount(balanceAmount);
                    } else {
                        const quotationTotalWithVat = Number(quotationData.amount) * (1 + vatRateValue);
                        setProformaInvoice([]);
                        setAmountReceived(0);
                        setBalanceAmount(quotationTotalWithVat);
                    }
                    if (response.data.quotation) {
                        setQuotationWithPricings(response.data.quotation);
                    }

                } catch (error) {
                    console.error('Error fetching Proforma Invoices:', error);
                }
            };

            fetchProformaInvoice();
        } else {
            setProformaInvoice(null);
            setAmountReceived();
            setBalanceAmount();
        }
    }, [showModal, quotationData.id]);

    if (!showModal) return null; // Don't render the modal if `showModal` is false
    const newAdvanceAmount = (quotationData.amount * (Number(invoicePercentage) || 0)) / 100;
    const updatedTotalReceived = (Number(amountReceived) || 0) + newAdvanceAmount;
    const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
    const backend = `${API}/api`; // Use this if you want to use dynamic API URL
    // const backendUrl = 'http://localhost/webzash/api'; // adjust if needed
    const apiKey = process.env.REACT_APP_API_KEY; // replace with actual key

    const headers = {
        'x-api-key': apiKey,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const ensureGroupExists = async (groupName, parentGroupName, cachedGroups = null) => {
        if (!groupName || !parentGroupName) {
            throw new Error("Both groupName and parentGroupName are required");
        }

        const groups = cachedGroups || (await axios.get(`${backend}/groups/index`, { headers })).data;

        const group = groups.find(g => g.Group.name === groupName);
        if (group) return group.Group.id;

        const parentGroup = groups.find(g => g.Group.name === parentGroupName);
        if (!parentGroup) throw new Error(`Parent group "${parentGroupName}" not found`);

        const payload = {
            Group: {
                name: groupName,
                parent_id: parentGroup.Group.id,
                code: null,
                affects_gross: 0,
            },
        };

        const { data: created } = await axios.post(`${backend}/groups/add`, payload, { headers });
        return created.id;
    };

    const ensureLedgerExists = async (ledgerName, groupId, type = 0, credit = false, cachedLedgers = null) => {
        const ledgers = cachedLedgers || (await axios.get(`${backend}/ledgers/index`, { headers })).data.data;

        const existing = ledgers.find(l => l.Ledger?.name === ledgerName);
        if (existing) return existing.Ledger.id;

        const payload = {
            Ledger: {
                name: ledgerName,
                code: null,
                group_id: groupId,
                op_balance: 0,
                op_balance_dc: credit ? "C" : "D",
                notes: "",
                type: type,
            }
        };

        const { data: created } = await axios.post(`${backend}/ledgers/add`, payload, { headers });
        return created?.data?.Ledger?.id || created.Ledger?.id;
    };

    const isInitialRecognized = async (projectId) => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const { data } = await axios.get(`${backendUrl}/api/revenue-recognition/check-initial`, {
            params: { project_id: projectId },
            headers: {
                Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
            },
        });
        return data.exists; // true/false
    };
    const isDeploymentRecognized = async (projectId) => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const { data } = await axios.get(`${backendUrl}/api/revenue-recognition/check-deployment`, {
            params: { project_id: projectId },
            headers: {
                Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
            },
        });
        return data.exists; // true/false
    };
    const classifyItems = (items) => {
        console.log("🔍 Using quotation fields including AMC");

        const monthlySubscription = parseFloat(quotationData.subscription_amount || 0);
        const subscriptionPeriod = parseInt(quotationData.subscription_period || 12);
        const deploymentAmount = parseFloat(quotationData.deplyment_amount || 0);
        const amcAmount = parseFloat(quotationData.amc_amount || 0);

        // Calculate totals
        const subscriptionAmount = monthlySubscription * subscriptionPeriod;
        const totalDeployment = deploymentAmount + amcAmount; // Include AMC in deployment if applicable

        console.log("📊 Subscription (total period):", subscriptionAmount);
        console.log("📊 Deployment + AMC:", totalDeployment);

        return {
            subscriptionAmount,
            deploymentAmount: totalDeployment
        };
    };
    const runBeforeEntry = async (createdInvoice, quotationData, revenueData = {}) => {
        try {
            const clientName = quotationData.project?.client?.name || 'Unknown Client';
            const currency = quotationData.project?.client?.currency || 'AED';
            const exchangeRate = parseFloat(quotationData.exchange_rate || 1);

            // 2️⃣ Determine if conversion is needed
            const needsConversion = currency !== 'AED';
            const invoiceNo = createdInvoice.ref_no;

            // --- Amounts from invoice
            // const deploymentAmount = parseFloat(revenueData.deploymentAmount || 0);
            // const subscriptionAmount = parseFloat(revenueData.subscriptionAmount || 0);
            const items = quotationWithPricings?.product_item_details || [];

            // 🔥 NEW — auto-calc amounts from product pricing
            // const { subscriptionAmount, deploymentAmount } = classifyItems(items);

            // // override revenueData
            // revenueData.subscriptionAmount = subscriptionAmount;
            // revenueData.deploymentAmount = deploymentAmount;
            const deploymentAmount = Number(createdInvoice.deployment_amount || 0);       // BASE (no VAT)
            const subscriptionAmount = Number(createdInvoice.subscription_amount || 0);   // BASE (no VAT)


            // VAT calculation based on invoice fields
            const basicAmount = parseFloat(createdInvoice.basic_amount || 0); // amount without VAT
            const totalWithVat = parseFloat(createdInvoice.total_with_vat || 0); // amount including VAT
            const vatAmount = totalWithVat - basicAmount;
            const deploymentAmountAED = needsConversion ? deploymentAmount * exchangeRate : deploymentAmount;
            const subscriptionAmountAED = needsConversion ? subscriptionAmount * exchangeRate : subscriptionAmount;
            const totalWithVatAED = needsConversion ? totalWithVat * exchangeRate : totalWithVat;
            const vatAmountAED = needsConversion ? vatAmount * exchangeRate : vatAmount;
            const date = new Date().toISOString().split('T')[0];



            // --- Fetch groups & ledgers
            const allGroups = (await axios.get(`${backend}/groups/index`, { headers })).data;
            const assetsGroupId = await ensureGroupExists("Accounts Receivable", "Assets", allGroups);
            const incomeGroupId = await ensureGroupExists("Direct Incomes", "Incomes", allGroups);
            const vatGroupId = await ensureGroupExists("Duties and Taxes", "Liabilities and Owners Equity", allGroups);
            const currentLiabilitiesGroupId = await ensureGroupExists("Current Liabilities", "Liabilities and Owners Equity", allGroups);

            const allLedgers = (await axios.get(`${backend}/ledgers/index`, { headers })).data.data;
            const clientLedgerId = await ensureLedgerExists(clientName, assetsGroupId, 0, false, allLedgers);
            const salesLedgerId = await ensureLedgerExists("Sales Income", incomeGroupId, 0, true, allLedgers);
            const deferredRevenueLedgerId = await ensureLedgerExists("Deferred Revenue", currentLiabilitiesGroupId, 0, true, allLedgers);
            const outputVatLedgerId = vatAmount > 0 ? await ensureLedgerExists("Output VAT", vatGroupId, 0, true, allLedgers) : null;

            // --- Check if initial journal already exists
            const projectId = quotationData.project_id;
            const initialExists = await isInitialRecognized(projectId);
            const deploymentExists = await isDeploymentRecognized(projectId);

            // --- Identify product types
            // const items = quotationData.product_item_details || [];

            // const hasSubscription = items.some(item => item.product?.revenue_type === "deferred");
            // const hasService = items.some(item => item.product?.revenue_type === "immediate");
            const hasSubscription = subscriptionAmount > 0;
            const hasService = deploymentAmount > 0;

            console.log("🔍 DEBUG - Journal Entry Conditions:");
            console.log("📊 subscriptionAmount:", subscriptionAmount);
            console.log("📊 deploymentAmount:", deploymentAmount);
            console.log("🔍 hasSubscription:", hasSubscription, "(subscriptionAmount > 0)");
            console.log("🔍 hasService:", hasService, "(deploymentAmount > 0)");
            console.log("🔍 initialExists:", initialExists);
            console.log("🔍 deploymentExists:", deploymentExists);
            console.log("🔍 Condition 1 - hasService && !initialExists:", hasService && !initialExists);
            console.log("🔍 Condition 2 - hasSubscription && !deploymentExists:", hasSubscription && !deploymentExists);
            console.log("🔍 deploymentAmountAED:", deploymentAmountAED);
            console.log("🔍 subscriptionAmountAED:", subscriptionAmountAED);
            console.log("🔍 baseAmount:", baseAmount);

            // --- Build journal entry
            let entryItems = [];

            // Debit A/R for total invoice
            entryItems.push({
                dc: "D",
                ledger_id: clientLedgerId,
                dr_amount: totalWithVatAED.toFixed(2),
                cr_amount: null,
            });

            // Credit Sales Income for deployment / one-time services
            if (hasService && !initialExists && deploymentAmountAED > 0) {
                entryItems.push({
                    dc: "C",
                    ledger_id: salesLedgerId,
                    dr_amount: null,
                    cr_amount: deploymentAmountAED.toFixed(2),
                });
            }

            // Credit Deferred Revenue for subscription items
            if (hasSubscription && !deploymentExists && subscriptionAmountAED > 0) {
                entryItems.push({
                    dc: "C",
                    ledger_id: deferredRevenueLedgerId,
                    dr_amount: null,
                    cr_amount: subscriptionAmountAED.toFixed(2),
                });
            }

            // Credit VAT if applicable
            if (vatAmountAED > 0 && outputVatLedgerId) {
                entryItems.push({
                    dc: "C",
                    ledger_id: outputVatLedgerId,
                    dr_amount: null,
                    cr_amount: vatAmountAED.toFixed(2),
                });
            }

            // --- Ensure DR = CR
            const toCents = val => Math.round(Number(val || 0) * 100);
            const totalDrCents = entryItems.reduce((sum, i) => sum + (i.dc === 'D' ? toCents(i.dr_amount) : 0), 0);
            const totalCrCents = entryItems.reduce((sum, i) => sum + (i.dc === 'C' ? toCents(i.cr_amount) : 0), 0);

            if (totalDrCents !== totalCrCents) {
                console.error("❌ Totals don't match (in cents). Aborting journal creation.");
                return;
            }

            // --- Final payload
            const payload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date,
                    narration: `Invoice ${invoiceNo} initial journal`,
                    client_id: quotationData?.project?.client_id,
                    project_id: projectId,
                },
                Entryitem: entryItems,
            };

            // --- Post to backend
            const { data: result } = await axios.post(`${backend}/entries/add/journal`, payload, { headers });
            console.log("✅ Initial journal created for invoice:", invoiceNo, result.entry_id);
            return result.entry_id;

        } catch (err) {
            console.error("❌ Error creating initial journal entry:", err);
            throw err;
        }
    };

    const deploymentDescriptions = quotationData?.editable_deployment_descriptions
        ? typeof quotationData.editable_deployment_descriptions === 'string'
            ? JSON.parse(quotationData.editable_deployment_descriptions)
            : quotationData.editable_deployment_descriptions
        : {};


    // const runBeforeEntry = async (createdInvoice, quotationData) => {
    //     const clientName = quotationData.project?.client?.name || 'Unknown Client';
    //     const currency = quotationData.project?.client?.currency || 'AED';
    //     const invoiceNo = createdInvoice.ref_no;
    //     const amount = parseFloat(createdInvoice.basic_amount || 0);
    //     const exchangeRate = parseFloat(quotationData.exchange_rate || 1);
    //     console.log('rate:', exchangeRate);
    //     const isAed = currency === 'AED';
    //     const isTaxInvoiceGenerated = isAed && createdInvoice.tax_invoice_generated === 1;
    //     const convertedAmount = isAed ? amount : amount * exchangeRate;

    //     const rawVat = isTaxInvoiceGenerated
    //         ? createdInvoice.vat_amount !== null && createdInvoice.vat_amount !== undefined
    //             ? parseFloat(createdInvoice.vat_amount)
    //             : parseFloat((convertedAmount * 0.05).toFixed(4))
    //         : 0;

    //     function roundTo2(val) {
    //         return parseFloat((Math.round(val * 100) / 100).toFixed(2));
    //     }

    //     // Then use it like this:
    //     const roundedAmount = parseFloat(roundTo2(convertedAmount));
    //     const roundedVat = parseFloat(roundTo2(rawVat));
    //     const roundedTotal = parseFloat(roundTo2(roundedAmount + roundedVat));

    //     const date = new Date().toISOString().split('T')[0];

    //     const allGroups = (await axios.get(`${backendUrl}/groups/index`, { headers })).data;
    //     const assetsGroupId = await ensureGroupExists("Accounts Receivable", "Assets", allGroups);
    //     const incomeGroupId = await ensureGroupExists("Sales", "Incomes", allGroups);
    //     const vatGroupId = await ensureGroupExists("Duties and Taxes", "Liabilities and Owners Equity", allGroups);
    //     const currentLiabilitiesGroupId = await ensureGroupExists("Current Liabilities", "Liabilities and Owners Equity", allGroups);


    //     const allLedgers = (await axios.get(`${backendUrl}/ledgers/index`, { headers })).data.data;
    //     const clientLedgerId = await ensureLedgerExists(clientName, assetsGroupId, 0, false, allLedgers);
    //     const deferredRevenueLedgerId = await ensureLedgerExists("Deferred Revenue", currentLiabilitiesGroupId, 0, true, allLedgers);

    //     const salesLedgerId = await ensureLedgerExists("Sales Income", incomeGroupId, 0, true, allLedgers);
    //     const outputVatLedgerId = isTaxInvoiceGenerated && roundedVat > 0
    //         ? await ensureLedgerExists("Output VAT", vatGroupId, 0, true, allLedgers)
    //         : null;
    //     const items = quotationData.product_item_details || [];
    //     // If ANY product in this invoice is subscription → treat as subscription
    //     const hasSubscription = items.some(item => item.product?.revenue_type === "deferred");
    //     const hasService = items.some(item => item.product?.revenue_type === "immediate");


    //     // const entryItems = [
    //     //     {
    //     //         dc: "D",
    //     //         ledger_id: clientLedgerId,
    //     //         dr_amount: roundedTotal,
    //     //         cr_amount: null,
    //     //     },
    //     //     {
    //     //         dc: "C",
    //     //         ledger_id: deferredRevenueLedgerId,
    //     //         dr_amount: null,
    //     //         cr_amount: roundedAmount,
    //     //     },
    //     // ];

    //     // if (isTaxInvoiceGenerated && roundedVat > 0 && outputVatLedgerId) {
    //     //     entryItems.push({
    //     //         dc: "C",
    //     //         ledger_id: outputVatLedgerId,
    //     //         dr_amount: null,
    //     //         cr_amount: roundedVat,
    //     //     });
    //     // }
    //     const projectId = quotationData.project_id;
    //     const initialExists = await isInitialRecognized(projectId);
    //     const deploymentExists = await isDeploymentRecognized(projectId);
    //     // let entryItems = [
    //     //     {
    //     //         dc: "D",
    //     //         ledger_id: clientLedgerId,
    //     //         dr_amount: roundedTotal,
    //     //         cr_amount: null,
    //     //     }
    //     // ];

    //     // // Case 1: Subscription product → Credit Deferred Revenue
    //     // if (!initialExists) {
    //     //     if (hasSubscription) {
    //     //         entryItems.push({
    //     //             dc: "C",
    //     //             ledger_id: deferredRevenueLedgerId,
    //     //             dr_amount: null,
    //     //             cr_amount: roundedAmount,
    //     //         });
    //     //     }

    //     //     // Case 2: One-time Professional Service → Credit Sales Income
    //     //     else if (hasService) {
    //     //         entryItems.push({
    //     //             dc: "C",
    //     //             ledger_id: salesLedgerId,
    //     //             dr_amount: null,
    //     //             cr_amount: roundedAmount,
    //     //         });
    //     //     }
    //     // }
    //     let entryItems = [
    //         {
    //             dc: "D",
    //             ledger_id: clientLedgerId,
    //             dr_amount: roundedTotal,
    //             cr_amount: null,
    //         }
    //     ];

    //     // One-time / Deployment (Immediate) → always credit Sales Income
    //     if (hasService && !deploymentExists) {
    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: salesLedgerId,
    //             dr_amount: null,
    //             cr_amount: roundedAmount,
    //         });
    //     }

    //     // Subscription (Deferred) → only credit Deferred Revenue if initial is false
    //     if (hasSubscription && !initialExists) {
    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: deferredRevenueLedgerId,
    //             dr_amount: null,
    //             cr_amount: roundedAmount,
    //         });
    //     }


    //     // Add VAT if applicable
    //     if (isTaxInvoiceGenerated && roundedVat > 0 && outputVatLedgerId) {
    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: outputVatLedgerId,
    //             dr_amount: null,
    //             cr_amount: roundedVat,
    //         });
    //     }


    //     console.log("🧮 Calculated Amount:", roundedAmount);
    //     console.log("🧮 Calculated VAT:", roundedVat);
    //     console.log("🧮 Final Rounded Total:", roundedTotal);
    //     console.log("🔍 Entry Items:");
    //     entryItems.forEach((item, idx) => {
    //         console.log(`  Item ${idx}: dc=${item.dc}, DR=${item.dr_amount}, CR=${item.cr_amount}`);
    //     });

    //     const toCents = val => Math.round(Number(val || 0) * 100);
    //     const totalDrCents = entryItems.reduce((sum, i) => sum + (i.dc === 'D' ? toCents(i.dr_amount) : 0), 0);
    //     const totalCrCents = entryItems.reduce((sum, i) => sum + (i.dc === 'C' ? toCents(i.cr_amount) : 0), 0);


    //     console.log("✅ Total DR raw:", totalDrCents / 100);
    //     console.log("✅ Total CR raw:", totalCrCents / 100);
    //     console.log("❌ Raw Cents Difference:", totalDrCents - totalCrCents);

    //     // Final safety rounding for backend
    //     entryItems.forEach(entry => {
    //         entry.dr_amount = entry.dr_amount !== null ? parseFloat(entry.dr_amount).toFixed(2) : "0.00";
    //         entry.cr_amount = entry.cr_amount !== null ? parseFloat(entry.cr_amount).toFixed(2) : "0.00";
    //     });




    //     if (totalDrCents !== totalCrCents) {
    //         console.error("❌ Totals don't match (in cents). Aborting journal creation.");
    //         return;
    //     }

    //     const payload = {
    //         Entry: {
    //             tag_id: null,
    //             number: Date.now(),
    //             date,
    //             narration: "",
    //             client_id: quotationData?.project?.client_id,
    //             project_id: quotationData?.project_id,
    //         },
    //         Entryitem: entryItems,
    //     };

    //     console.log("📦 Final Payload:", JSON.stringify(payload, null, 2));
    //     console.log("🔍 Types Check:");
    //     entryItems.forEach((item, i) => {
    //         console.log(`Item ${i}: DR=${item.dr_amount} (${typeof item.dr_amount}), CR=${item.cr_amount} (${typeof item.cr_amount})`);
    //     });

    //     try {
    //         const { data: result } = await axios.post(`${backendUrl}/entries/add/journal`, payload, { headers });
    //         console.log("✅ Double entry created:", result);
    //         Swal.fire({
    //             toast: true,
    //             position: 'top-end',
    //             icon: 'success',
    //             title: `Invoice Created Successfully`,
    //             timer: 3000,
    //             showConfirmButton: false,
    //         });
    //         const webzashEntryId = result.entry_id;
    //         return webzashEntryId;



    //     } catch (err) {
    //         const message =
    //             err?.response?.data?.message ||
    //             err.message ||
    //             "Unknown error occurred during journal entry";

    //         console.error("❌ Error creating journal entry:", message);

    //         Swal.fire({
    //             toast: true,
    //             position: 'top-end',
    //             icon: 'error',
    //             title: `Journal Entry Failed: ${message}`,
    //             timer: 3000,
    //             showConfirmButton: false,
    //         });

    //         throw new Error(message);
    //     }
    // };



    // Add this component in your form to show VAT status
const VatStatusDisplay = () => {
    const vatEffectiveDate = new Date('2020-09-01');
    const currentInvoiceDate = new Date(invoiceDate);
    const clientCurrency = quotationData?.project?.client?.currency || 'AED';
    
    const shouldApplyVAT = clientCurrency === 'AED' && currentInvoiceDate >= vatEffectiveDate;
    const isBeforeVAT = clientCurrency === 'AED' && currentInvoiceDate < vatEffectiveDate;

    return (
        <div className="vat-status-section mb-3 p-3 border rounded bg-light">
            <h6 className="fw-bold mb-2">VAT Status</h6>
            <div className="row">
                <div className="col-6">
                    <div className="small text-muted">Invoice Date</div>
                    <div className="fw-semibold">{new Date(invoiceDate).toLocaleDateString()}</div>
                </div>
                <div className="col-6">
                    <div className="small text-muted">VAT Application</div>
                    <div className={`fw-bold ${shouldApplyVAT ? 'text-success' : 'text-secondary'}`}>
                        {shouldApplyVAT ? 'VAT Applied (5%)' : 'No VAT'}
                        {isBeforeVAT && ' - Pre-VAT Period'}
                    </div>
                </div>
            </div>
            {isBeforeVAT && (
                <div className="mt-2 small text-warning">
                    <i className="bi bi-info-circle"></i> Invoices before September 2020 are not subject to VAT in UAE
                </div>
            )}
        </div>
    );
};
    return (
        <>
         {showModal && (
    <div
        className="custom-backdrop"
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.25)', // light dim (Bootstrap style)
            zIndex: 1059, // between parent & child offcanvas
        }}
        onClick={handleClose}
    />
)}


            <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '500px' }}>
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="fw-bold">Create Proforma Invoice</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="p-4">
                    <Form>
                        {/* Invoice Header */}
                        <div className="invoice-header mb-4 p-3 bg-light rounded">
                            <h6 className="fw-bold mb-3 text-dark">Invoice Summary</h6>
                            {/* <VatStatusDisplay /> */}

                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <small className="text-muted d-block">Client</small>
                                            <span className="fw-semibold">{quotationData.project?.client?.name || ''}</span>
                                        </div>
                                        <div className="text-end">
                                            <small className="text-muted d-block">Project</small>
                                            <span className="fw-semibold">{quotationData.project?.name || ''}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="amount-breakdown border-top pt-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <small className="text-muted d-block">Contract Value</small>
                                                <div className="fw-bold text-primary fs-6">
                                                    {Number(quotationData.amount || 0).toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                            </div>
                                            {/* <div className="text-end">
                                                <small className="text-muted d-block">
                                                    {clientCurrency === 'AED' ? 'VAT (5%)' : 'VAT (0%)'}
                                                </small>
                                                <div className="fw-semibold">
                                                    {clientCurrency === 'AED' ?
                                                        (quotationData.amount * 0.05).toLocaleString('en-AE', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) :
                                                        '0.00'
                                                    }
                                                </div>
                                            </div> */}
                                             <div className="text-end">
                        <small className="text-muted d-block">
                            {vatRate > 0 ? 'VAT (5%)' : 'VAT (0%)'}
                        </small>
                        <div className="fw-semibold">
                            {vatRate > 0 ?
                                (quotationData.amount * 0.05).toLocaleString('en-AE', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }) :
                                '0.00'
                            }
                        </div>
                    </div>
                                            <div className="text-end">
                                                <small className="text-muted d-block">Total Amount</small>
                                                <div className="fw-bold text-success fs-6">
                                                    {totalContractWithVat.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Invoice Date Field */}
                        {/* <div className="invoice-date-section mb-3">
                            <Form.Group controlId="invoice_date">
                                <Form.Label className="small fw-semibold">Invoice Date *</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={invoiceDate}
                                    onChange={handleDateChange}
                                    required
                                />
                                 {isDateLocked && (
        <Alert variant="danger" className="mt-2">
            <i className="mdi mdi-lock me-1"></i>
            This financial period is locked! You cannot create invoices for this date.
        </Alert>
    )}

                            </Form.Group>
                        </div> */}
                        <Form.Group controlId="invoice_date">
    <Form.Label className="small fw-semibold">Invoice Date *</Form.Label>
    <Form.Control
        type="date"
        value={invoiceDate}
        onChange={handleDateChange}
        required
        className={formErrors.dateLocked ? 'is-invalid' : ''}
        max={new Date().toISOString().split('T')[0]}
    />
    
    {/* Show validation error from formErrors */}
    {formErrors.dateLocked && (
        <div className="invalid-feedback d-block">
            <div className="d-flex align-items-start">
                <i className="bi bi-exclamation-circle-fill me-1 mt-1"></i>
                <div>
                    <strong>Period Locked</strong>
                    <div className="small">
                        {lockError?.period ? (
                            <>
                                Cannot create invoice for {format(parseISO(lockError.date), 'dd MMM yyyy')}<br/>
                                <span className="text-muted">
                                    Locked Period: {lockError.period.year_label} ({format(parseISO(lockError.period.start_date), 'dd MMM')} - {format(parseISO(lockError.period.end_date), 'dd MMM yyyy')})
                                </span>
                            </>
                        ) : (
                            `Cannot create invoice for ${invoiceDate} - Period is locked`
                        )}
                    </div>
                </div>
            </div>
        </div>
    )}
</Form.Group>

                        {/* Amount Input Section */}
                        <div className="amount-section mb-4">
                            <h6 className="fw-bold mb-3">Invoice Amount</h6>
                            <div className="row g-3">
                                <div className="col-6">
                                    <Form.Group controlId="invoice_percentage">
                                        <Form.Label className="small fw-semibold">Percentage (%)</Form.Label>
                                        <Form.Control
                                            className={`invoice-input ${formErrors.invoicePercentage ? 'is-invalid' : ''}`}
                                            type="number"
                                            step="0.01"
                                            value={invoicePercentage}
                                            onChange={(e) => {
                                                setInvoicePercentage(e.target.value);
                                                handleInvoicePercentageChange(e.target.value);
                                                if (formErrors.invoicePercentage) {
                                                    setFormErrors(prev => ({ ...prev, invoicePercentage: '' }));
                                                }
                                            }}
                                            placeholder="0.00"
                                            Required
                                        />
                                        {formErrors.invoicePercentage && (
                                            <div className="invalid-feedback" style={{ fontSize: '12px' }}>
                                                {formErrors.invoicePercentage}
                                            </div>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className="col-6">
                                    <Form.Group controlId="invoice_amount">
                                        <Form.Label className="small fw-semibold">
                                            Total Amount {vatRate > 0 ? '(With VAT)' : ''}
                                        </Form.Label>
                                        <Form.Control
                                            className="invoice-input"
                                            type="number"
                                            step="0.01"
                                            value={invoiceAmount}
                                            onChange={(e) => handleInvoiceAmountChange(e.target.value)}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>

                        {/* Revenue Split Section */}
                        <div className="revenue-split-section mb-4">
                            <h6 className="fw-bold mb-3">Revenue Allocation</h6>

                            {deploymentTotal > 0 && (
                                <div className="revenue-category mb-4">
                                    <div className="category-header mb-2">
                                        <h6 className="fw-semibold text-primary mb-1">Deployment</h6>
                                    </div>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-semibold">
                                            Deployment Amount {vatRate > 0 ? '(With VAT)' : ''}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="revenue-input"
                                            value={deploymentInput}
                                            onChange={e => handleDeploymentChange(e.target.value)}
                                            onBlur={handleDeploymentBlur}
                                            placeholder="0.00"
                                        />
                                        <Form.Text className="small text-muted">
                                            {revenueAmounts.deployment.percentage.toFixed(1)}% of remaining deployment
                                            {vatRate > 0 && ` | Base: ${revenueAmounts.deployment.amount.toFixed(2)}`}
                                        </Form.Text>
                                    </Form.Group>

                                    {/* FIXED: Deployment Summary */}
                                    <div className="summary-card p-3 border rounded bg-light">
                                        <h6 className="small fw-bold mb-2">Deployment Summary</h6>
                                        <div className="summary-grid">
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Total Contract:</span>
                                                <span className="fw-semibold">
                                                    {deploymentTotal.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            {vatRate > 0 && (
                                                <div className="summary-item d-flex justify-content-between small">
                                                    <span>VAT Amount:</span>
                                                    <span className="fw-semibold">{(deploymentTotal * vatRate).toFixed(2)}</span>
                                                </div>
                                            )}
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Total Generated:</span>
                                                <span className="fw-semibold">
                                                    {totalDeploymentReceived.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Remaining Balance:</span>
                                                <span className={`fw-semibold ${deploymentBalance <= 0 ? 'text-success' : 'text-warning'}`}>
                                                    {deploymentBalance.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            <div className="summary-item d-flex justify-content-between small border-top pt-1">
                                                <span className="fw-bold">Current Invoice:</span>
                                                <span className="text-primary">
                                                    {revenueAmounts.deployment.amount.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                    {vatRate > 0 && (
                                                        <small className="text-muted">
                                                            + {(revenueAmounts.deployment.amount * vatRate).toLocaleString('en-AE', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })} VAT
                                                        </small>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {subscriptionTotal > 0 && (
                                <div className="revenue-category">
                                    <div className="category-header mb-2">
                                        <h6 className="fw-semibold text-success mb-1">Subscription</h6>
                                    </div>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-semibold">
                                            Subscription Amount {vatRate > 0 ? '(With VAT)' : ''}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="revenue-input"
                                            value={subscriptionInput}
                                            onChange={e => handleSubscriptionChange(e.target.value)}
                                            onBlur={handleSubscriptionBlur}
                                            placeholder="0.00"
                                        />
                                        <Form.Text className="small text-muted">
                                            {revenueAmounts.subscription.percentage.toFixed(1)}% of remaining subscription
                                            {vatRate > 0 && ` | Base: ${revenueAmounts.subscription.amount.toFixed(2)}`}
                                        </Form.Text>
                                    </Form.Group>

                                    {/* FIXED: Subscription Summary */}
                                    <div className="summary-card p-3 border rounded bg-light">
                                        <h6 className="small fw-bold mb-2">Subscription Summary</h6>
                                        <div className="summary-grid">
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Total Contract:</span>
                                                <span className="fw-semibold">
                                                    {subscriptionTotal.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            {vatRate > 0 && (
                                                <div className="summary-item d-flex justify-content-between small">
                                                    <span>VAT Amount:</span>
                                                    <span className="fw-semibold">{(subscriptionTotal * vatRate).toFixed(2)}</span>
                                                </div>
                                            )}
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Total Generated:</span>
                                                <span className="fw-semibold">
                                                    {totalSubscriptionReceived.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            <div className="summary-item d-flex justify-content-between small">
                                                <span>Remaining Balance:</span>
                                                <span className={`fw-semibold ${subscriptionBalance <= 0 ? 'text-success' : 'text-warning'}`}>
                                                    {subscriptionBalance.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                            </div>
                                            <div className="summary-item d-flex justify-content-between small border-top pt-1">
                                                <span className="fw-bold">Current Invoice:</span>
                                                <span className="text-primary">
                                                    {revenueAmounts.subscription.amount.toLocaleString('en-AE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                    {vatRate > 0 && (
                                                        <small className="text-muted ">
                                                            + {(revenueAmounts.subscription.amount * vatRate).toLocaleString('en-AE', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })} VAT
                                                        </small>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="payment-summary-section border-top pt-3">
                            <h6 className="fw-bold mb-3">Payment Summary</h6>
                            <div className="summary-cards">
                                <div className="row g-3">
                                    <div className="col-6">
                                        <div className="summary-item-card p-3 border rounded h-100">
                                            <div className="small text-muted mb-1">Total Generated</div>
                                            <div className="fw-bold text-success fs-6">
                                                {Number(amountReceived || 0).toLocaleString('en-AE', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-6">
                                        <div className="summary-item-card p-3 border rounded h-100">
                                            <div className="small text-muted mb-1">Remaining Balance</div>
                                            <div className="fw-bold text-warning fs-6">
                                                {invoicePercentage
                                                    ? calculateUpdatedBalancePercentage()
                                                    : balanceAmount >= 0
                                                        ? `${((balanceAmount / (quotationData.amount * (clientCurrency === "AED" ? 1.05 : 1))) * 100).toFixed(2)}%`
                                                        : "0%"}
                                            </div>
                                        </div> */}
                                        <div className="col-6">
                <div className="summary-item-card p-3 border rounded h-100">
                    <div className="small text-muted mb-1">Remaining Balance</div>
                    <div className="fw-bold text-warning fs-6">
                        {invoicePercentage
                            ? calculateUpdatedBalancePercentage()
                            : balanceAmount >= 0
                                ? `${((balanceAmount / totalContractWithVat) * 100).toFixed(2)}%`
                                : "0%"}
                    </div>
                    <div className="small text-muted mt-1">
                        {Number(balanceAmount || 0).toLocaleString('en-AE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })} {clientCurrency}
                    </div>
                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Offcanvas.Body>

                <div className="p-4 d-flex justify-content-end border-top bg-light">
                    <Button
                        variant="outline-secondary"
                        onClick={handleClose}
                        className="me-2"
                        size="sm"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCreateProformaInvoice}
                        size="sm"
                    >
                        Create Invoice
                    </Button>
                </div>
                <style jsx>{`
                .invoice-input, .revenue-input {                     font-size: 14px;
                     border: 1px solid #e8e9ed;
                     border-radius: 4px;
                 }

                 .invoice-input:focus, .revenue-input:focus {
                     border-color: #0d6efd;
                     box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
                 }

                 .summary-card {
                     background: #f8f9fa !important;
                 }

                 .summary-item-card {
                   background: white;
                     transition: all 0.2s ease;
                }

                 .summary-item-card:hover {
                      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                  }
             `}</style>
            </Offcanvas>
            <ProformaInvoicePreview
                showModal={showPreviewModal}
                handleClose={handleClosePreview}
                createdInvoice={createdInvoice}
                quotationData={quotationData}
                customIntegration={customIntegration}
                setCustomIntegration={setCustomIntegration}
                editableDeploymentIntegration={deploymentDescriptions}
                setEditableDeploymentIntegration={setEditableDeploymentIntegration}
                customIntegrationDescription={quotationData.custom_integration_description}
                setCustomIntegrationDescription={setCustomIntegrationDescription}
                onDownloadPDF={handleDownloadPDF}
            />
        </>

    );

};

export default ProformaInvoiceModal;